import { useState } from 'react';
import { LGBTButton } from '../../components/lgbtButton/LGBTButton'
import styles from './PassReset.module.css'
import {Input} from "antd";
export const PassReset = () =>{
    const expression: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
    const [email,setEmail] = useState("")
    const isCheck: boolean = expression.test(email);

    return(
        <div className={styles.pass_reset_container}>
            <div className={styles.pass_reset_title}>Укажите почту для сброса пароля</div>
            <Input
                placeholder={"Ваша почта (обязательное поле)"}
                onChange={(e)=>setEmail(e.target.value)}
                value={email} />
            {!isCheck&&<LGBTButton
                colors={["gray","gray"]}
                text={"СБРОСИТЬ ПАРОЛЬ"}
                textSize={"16px"}
                textColor={"white"}
                onClick={()=>{}}/>}
            {isCheck&&<LGBTButton
                colors={["#F6503C","#E8AA18","#96C833","#318FC2","#10406E"]}
                text={"СБРОСИТЬ ПАРОЛЬ"}
                textSize={"16px"}
                textColor={"white"}
                onClick={()=>{}}/>}
        </div>
    )
}